import React, { Component } from "react";

import getFaqMenus from "../../lib/getFaqMenus";
import Api from "../../lib/componentApi";

import Loading from "../Common/Loading";
import emailRegex from "../../lib/emailRegex";
import getHeaderData from "../../lib/getHeaderData";

export default class Help extends Component {
  constructor(props, staticContext) {
    super(props);
    const { initialData } = getHeaderData(staticContext, "user");
    this.state = {
      faqMenus: getFaqMenus(),
      selectedFaqId: null,
      customContact: false,
      userEmail: "",
      helpText: "",
      helpInfo: false,
      lettersNumber: 0,
      defaultEmail: (initialData || {}).email,
      firstName: (initialData || {}).firstName,
      lastName: (initialData || {}).lastName,
    };
  }

  onChange = e => {
    event.preventDefault();
    const { lettersNumber } = this.state || 0;
    const targetId = e.target.id;
    if (targetId === "helpText") {
      if (lettersNumber < 140) {
        this.setState({
          [targetId]: e.target.value,
          lettersNumber: e.target.value.length
        });
      } else {
        event.preventDefault();
      }
    } else {
      this.setState({
        [targetId]: e.target.value
      });
    }
  };

  onSubmitHelp = () => {
    const { defaultEmail, userEmail, helpText } = this.state;
    const email = defaultEmail || userEmail;
    if (emailRegex(email)) {
      Api.post(
        "/api/contact/us",
        { email, message: helpText },
        (response, errors) => {
          if (errors) {
            if (errors === 503) {
              this.setState(() => {
                throw errors;
              });
            } else {
              console.log(errors);
            }
          } else if (response.code) {
            console.log("code-contact-us");
          } else {
            if (response.status) {
              var body = document.body;
              body.classList.add("body-overflow");
              this.setState({
                helpInfo: true
              });
            }
          }
        }
      );
    }
  };
  handleControlAccordion = faqId => {
    const { selectedFaqId } = this.state;
    if (selectedFaqId === faqId) {
      this.setState({ selectedFaqId: null });
    } else {
      this.setState({ selectedFaqId: faqId });
    }
  };
  handleSelectCustomContact = () => {
    const intercomSettings = {
      app_id: "hqblgstm",
      name: `${this.state.firstName} ${this.state.lastName}`,
      email: this.state.defaultEmail
    };
    window.Intercom('boot', intercomSettings);
    window.Intercom('show')
  };
  onCloseSection = () => {
    const { onCloseSection } = this.props;
    if (onCloseSection) {
      var body = document.body;
      body.classList.remove("body-overflow");
      onCloseSection("help");
    } else {
      window.location.href = "/";
    }
  };
  render() {
    const {
      faqMenus,
      defaultEmail,
      selectedFaqId,
      customContact,
      userEmail,
      helpInfo,
      lettersNumber,
      helpText
    } = this.state;
    return (
      <div>
        {/* Header */}
        <div className="head-general with-back visible-xs">
          {(customContact && (
            <a
              className="back cursor-pointer"
              onClick={this.handleSelectCustomContact}
            >
              <img src="/png/chevron-left.png" />
            </a>
          )) || <a className="back cursor-pointer" />}

          <h4>{(helpInfo && "Thank You") || "Help"}</h4>
          <a onClick={this.onCloseSection} className="close cursor-pointer">
            <i className="icon icon-close" />
          </a>
        </div>
        {/* Header */}
        <div className="container">
          {(!customContact &&
            ((faqMenus && faqMenus.length && (
              <div className="static help white-bg">
                <div className="mt-10px main-div">
                  <div className="item">
                    {faqMenus.map(faq => {
                      const matched = selectedFaqId === faq.id;
                      return (
                        <React.Fragment key={faq.id}>
                          <div className="accordion-tab white-bg">
                            <div className="item">
                              <div
                                className="item accordion-button"
                                onClick={() =>
                                  this.handleControlAccordion(faq.id)
                                }
                              >
                                <h4>{faq.title}</h4>
                                <div>
                                  <icon
                                    className={
                                      "icon icon-arrow-3 " +
                                      ((matched && "open") || "")
                                    }
                                  />
                                </div>
                              </div>
                            </div>
                            <ul
                              className={
                                "body accordion-panel" +
                                ((matched && "-active") || "")
                              }
                            >
                              {(faq.posts &&
                                faq.posts.length &&
                                faq.posts.map((post, index) => (
                                  <li key={index}>
                                    <h5>{post.bodyTitle}</h5>
                                    <p
                                      dangerouslySetInnerHTML={{
                                        __html: `${post.bodyText}`
                                      }}
                                    />
                                  </li>
                                ))) || <noscript />}
                            </ul>
                          </div>
                        </React.Fragment>
                      );
                    })}
                  </div>
                  <div id="contact-us" className="foot">
                    <p className="bold">Can’t find your problem here?</p>
                    <p>Please write to us at</p>
                    <p className="mt-10px">
                      <a
                        className="color-blue"
                        href="mailto:support@mylocale.co.uk"
                      >
                        support@mylocale.co.uk
                      </a>
                    </p>
                    {(defaultEmail && <p className="mt-10px">or</p>) || null}
                  </div>
                  <div className="use-buttons">
                    <button
                      className="btn btn-gray"
                      onClick={this.handleSelectCustomContact}
                    >
                      Chat with us
                    </button>
                  </div>
                </div>
              </div>
            )) || <Loading />)) || (
            <React.Fragment>
              <div className="static help white-bg">
                {(helpInfo && (
                  <div>
                    <div className="modal-bg" />
                    <div className="modal">
                      <div className="head-general with-back">
                        <a />
                        <h4 className="info-title">Thanks</h4>
                        <a
                          className="close cursor-pointer"
                          onClick={this.onCloseSection}
                        >
                          <icon className="icon icon-close" />
                        </a>
                      </div>
                      <div className="modal-body">
                        <div className="promo-error white-bg">
                          <p>Thank you for sharing your thoughts with us.</p>
                        </div>
                        <div className="use-buttons">
                          <button
                            className="btn btn-blue"
                            onClick={this.onCloseSection}
                          >
                            OK
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                )) || <noscript />}
                <div className="help-form">
                  <div className="form mt-10px">
                    <h4 className="mb-10px hide-xs">Help</h4>
                    {(!defaultEmail && (
                      <div className="form-group">
                        <input
                          id="userEmail"
                          className="form-input"
                          value={userEmail}
                          type="text"
                          placeholder="E-Mail Address"
                          onChange={e => this.onChange(e)}
                        />
                      </div>
                    )) || <noscript />}
                    <textarea
                      id="helpText"
                      value={helpText}
                      onChange={e => this.onChange(e)}
                      placeholder="Please check our FAQs if you have an issue with your order. If you can't find an answer you can get in touch via Live Chat or leave a message here."
                    />
                    <span className="small-label">{lettersNumber}/140</span>
                  </div>
                  <div className="use-buttons">
                    <button
                      className="btn btn-blue"
                      onClick={this.onSubmitHelp}
                    >
                      Send
                    </button>
                  </div>
                </div>
              </div>
            </React.Fragment>
          )}
        </div>
      </div>
    );
  }
}
